import React from "react";
import { useTranslation } from "react-i18next";
import "./history.css";
import SectionWrapper from "../components/ComponentWrapper/SectionWrapper";
import BreathingBackground from "../components/BreathingBackground/BreathingBackground";

const History = () => {
  const { t } = useTranslation();

  return (
    <BreathingBackground>
    <SectionWrapper>
    <article className="history-page">
      {/* HERO */}
      <header className="history-hero">
        <h1>{t("history.title", "History")}</h1>
        <p>{t("history.subtitle", "Continuity, memory, and collective practice")}</p>
      </header>

      {/* ORIGEN */}
      <section className="history-section">
        <h2>{t("history.originTitle", "Origins")}</h2>
        <p>
          {t(
            "history.originText",
            "Kujipy emerges from the musical tradition of Santa María Tlahuitoltepec, Oaxaca, a community internationally recognized for its strong musical education and collective organization."
          )}
        </p>
      </section>

      {/* CONTINUIDAD */}
      <section className="history-section highlight">
        <h2>{t("history.continuityTitle", "Continuity and transmission")}</h2>
        <p>
          {t(
            "history.continuityText",
            "The music performed by Kujipy is transmitted across generations. Knowledge is shared through communal learning, rehearsals, and participation in festivities."
          )}
        </p>
        <p>
          {t(
            "history.continuityText2",
            "This continuity ensures that the repertoire remains alive, adapting to new contexts without losing its cultural foundation."
          )}
        </p>
      </section>

      {/* PRESENTE */}
      <section className="history-section">
        <h2>{t("history.presentTitle", "Kujipy today")}</h2>
        <p>
          {t(
            "history.presentText",
            "Today, Kujipy shares this musical tradition in both local and international contexts, presenting Mixe music as a living cultural expression rooted in community life."
          )}
        </p>
      </section>
    </article>
    </SectionWrapper>
    </BreathingBackground>
  );
};

export default History;